import urlHelper from "@/helpers/urlHelper";
import store from "@/store/index";
import apiHelper from "@/helpers/apiHelper"
import validators from "@/helpers/validators";
import moment from "moment";

export default {
    clearCache() {
        //store.commit("updateSid", null);
        store.commit("updateAccountInfo", null);

        store.commit("updateSearchResults", null);
        store.commit("updateSelectedArea", null);
        store.commit("updateSelectedBooking", null);
        store.commit("updateQrCodeValue", null);
    },
    logout() {
        //logout public API and CAS
        const afterLogoutCallback = () => {
            this.clearCache();
        }

        apiHelper.logout(afterLogoutCallback)
    },
    casLogout() {
        //Log out CAS only as Public API is already logged out
        this.clearCache();

        apiHelper.casLogout()
    },
    im8Logout() {
        //Logout CAS only as Public API is already logged out

        //Logout caused by concurrent session login or session inacitivity timeout.
        //It is indicated by status code 401 or window.$msg.reloginRequired,
        //all API calls should handle it this way, except for Login

        //1. The user application session is cleared.
        this.clearCache();

        //2. A user friendly message “Your session has expired. Please log in again.” will be displayed.
        store.commit("updateResult", {
            show: true,
            success: false,
            title: window.$msg.reloginRequiredTitle,
            message: window.$msg.reloginRequired,
        });

        //3. Log out user from CAS, and then go to homepage after
        setTimeout(() => {
            apiHelper.casLogout();
        }, 3000);
    },
    commonResponseHandler(response, successMessage, errorMessage,
        alwaysCallback, successCallback, errorCallback, hideResult) {
        let title = errorMessage;
        let success = false;

        if (response && response.data) {
            title = successMessage;
            success = true;

            if (!hideResult) {
                store.commit("updateResult", { show: true, success: success, title: title });
            }

            store.commit("updateAccountInfo", response.data.accountInfo);

            if (successCallback) {
                successCallback();
            }
        } else {
            //Force window.$msg.reloginRequired to be shown even for auto checking that's running background
            if (!hideResult || response === window.$msg.reloginRequired) {
                if (response === window.$msg.reloginRequired) {
                    title = window.$msg.reloginRequiredTitle;
                }

                store.commit("updateResult", {
                    show: true,
                    success: success,
                    title: title,
                    message: response,
                });
            }

            if (response === window.$msg.reloginRequired) {
                //The user application session will be cleared.
                this.clearCache();

                setTimeout(() => {
                    this.casLogout();
                }, 3000)

                return window.$msg.reloginRequired;
            }

            if (errorCallback) {
                errorCallback();
            }
        }

        if (alwaysCallback) {
            alwaysCallback();
        }

        return success;
    },
    getLocationInfoFromQrCode(qrCode, branchMenus) {
        if (qrCode && branchMenus) {
            const locationInfo = urlHelper.validateAreaQrCode(qrCode);

            if (locationInfo) {
                const branchMenu = branchMenus.find(
                    (x) => x.code.toLowerCase() === locationInfo.branchCode.toLowerCase()
                );

                if (branchMenu) {
                    locationInfo.branchId = branchMenu.id;

                    // console.log("getLocationInfoFromQrCode", locationInfo);
                    return locationInfo;
                }
            }
        }

        return null;
    },
    getCurrentBranchName() {
        return store.getters.currentBranchName
    },
    getDwellTimeMinutes(holidays, branchDwellTime, bookingDateString) {
        if (branchDwellTime) {
            const dayOfWeek = moment(bookingDateString).day();
            let dwellMinutesOfTheDay = branchDwellTime.weeklyMaxDwellMinutes[dayOfWeek];

            if (branchDwellTime.holidayMaxDwellMinutes > 0) {
                //Get holidays - HolidayMaxDwellMinutes overrides WeeklyMaxDwellMinutes if it's greater than zero
                const hitHoliday = holidays.some(x => validators.isBetweenDate(bookingDateString, x.startTime, x.endTime));

                if (hitHoliday) {
                    dwellMinutesOfTheDay = branchDwellTime.holidayMaxDwellMinutes;
                }
            }

            if (dwellMinutesOfTheDay > 0) {
                return dwellMinutesOfTheDay;
            }
        }

        return null;
    },
    updateAccountStateAfterLogin(response) {
        if (response && response.data) {
            //store.commit("updateSid", response.data.sessionId);
            store.commit("updateSettings", response.data.settings);
            store.commit("updateAccountInfo", response.data.accountInfo);
        }
    },
    updateQrCodeValue(response) {
        if (response) {
            store.commit("updateQrCodeValue", response);
        }
    },
    timeDiffInSeconds(currentTime, startTime) {
        const duration =
            moment(currentTime).diff(
                moment(startTime)
            );
        const durationInSeconds =
            moment.duration(duration).asSeconds()

        return durationInSeconds;
    },
    isOtpTimerRunning(totalSeconds, now, isTrigger) {
        const timer = store.state.otpTimer;

        if (!isTrigger && !timer.isLoading) {
            return;
        }

        let otpTimerStartTime = store.state.otpTimerStartTime;

        if (timer.timerInterval) {
            clearInterval(timer.timerInterval);
            timer.timerInterval = {};
        }

        //if the pass time > remaining time then reset only instead resume,
        //so need to update otpTimer.timerinSeconds 
        //start timer               8:00:00 60
        //refresh page, timer stop  8:00:05 55
        //reload page, resume timer 8:00:10 50 <--need to set
        const timeDiff = this.timeDiffInSeconds(now, otpTimerStartTime);

        if (timeDiff > 0 && timeDiff < totalSeconds
        ) {
            const latestTimerInSeconds = totalSeconds - timeDiff;
            timer.timerInSeconds = latestTimerInSeconds;
        }
        else if (!isTrigger) {
            this.resetOtpTimer();
            return
        }

        timer.timerInterval = setInterval(() => {

            if (timer.timerInSeconds <= 0) {
                this.resetOtpTimer();
            } else {
                timer.timerInSeconds -= 1;
                timer.progressPercentage =
                    (timer.timerInSeconds / totalSeconds) * 100;

                store.commit("updateOtpTimer", {
                    timerInSeconds: timer.timerInSeconds,
                    progressPercentage: timer.progressPercentage,
                    timerInterval: timer.timerInterval,
                    isLoading: true,
                });

                if (isTrigger) {
                    store.commit("updateOtpTimerStartTime", now)
                }
            }
        }, 1000);
    },
    resetOtpTimer() {
        const timer = store.state.otpTimer;

        timer.timerInSeconds = window.$settings.resendOtpTimeIntervalInSeconds;
        timer.progressPercentage = 100;

        if (timer.timerInterval) {
            clearInterval(timer.timerInterval);
            timer.timerInterval = {};
        }

        store.commit("updateOtpTimer", {
            timerInSeconds: timer.timerInSeconds,
            progressPercentage: timer.progressPercentage,
            isLoading: false,
        });
    },
}
